import React from "react";

function TruckL() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="49.39"
      height="24.082"
      viewBox="0 0 49.39 24.082"
    >
      <g transform="translate(.325 .325)">
        <path
          d="M486.155 53.8a3.75 3.75 0 01-7.264-1.307"
          className="cls-1"
          transform="translate(-472.33 -32.814)"
        ></path>
        <path
          d="M533.05 53.8a3.749 3.749 0 01-7.264-1.307"
          className="cls-1"
          transform="translate(-495.792 -32.814)"
        ></path>
        <path
          d="M498.126 56.246h-1.418a3.749 3.749 0 01-3.749-3.749"
          className="cls-1"
          transform="translate(-479.368 -32.814)"
        ></path>
        <path
          d="M545.062 56.246H543.6a3.749 3.749 0 01-3.749-3.749"
          className="cls-1"
          transform="translate(-502.83 -32.814)"
        ></path>
        <path
          d="M527.661 31.856v-15h1.874v15"
          className="cls-1"
          transform="translate(-496.73 -14.984)"
        ></path>
        <path
          d="M531.412 16.859h5.638a3.749 3.749 0 012.917 1.394l6.027 7.464a1.873 1.873 0 01.416 1.178v4.961"
          className="cls-1"
          transform="translate(-498.607 -14.984)"
        ></path>
        <path
          d="M535.164 27.874v-7.03a.235.235 0 01.234-.234h4.251a1.406 1.406 0 011.092.519l5.358 6.6a.234.234 0 01-.181.382H535.4a.235.235 0 01-.236-.237z"
          className="cls-1"
          transform="translate(-500.484 -16.861)"
        ></path>
        <path
          d="M490.146 29.979V13.107h17.326a1.421 1.421 0 011.42 1.42v15.452"
          className="cls-1"
          transform="translate(-477.961 -13.107)"
        ></path>
        <path
          d="M467.637 29.979V14.527a1.42 1.42 0 011.42-1.42h9.828"
          className="cls-1"
          transform="translate(-466.7 -13.107)"
        ></path>
        <path
          d="M490.146 46.871h3.378"
          className="cls-2"
          transform="translate(-477.961 -29.999)"
        ></path>
        <path
          d="M511.09 46.871h16.287"
          className="cls-1"
          transform="translate(-488.439 -29.999)"
        ></path>
        <path
          d="M557.672 46.871h1.406a1.406 1.406 0 110 2.812h-1.406"
          className="cls-1"
          transform="translate(-511.745 -29.999)"
        ></path>
        <path
          d="M526.244 52.5h-15.466"
          className="cls-1"
          transform="translate(-488.283 -32.815)"
        ></path>
        <rect
          width="13.122"
          height="2.812"
          className="cls-1"
          rx="1.406"
          transform="translate(0 16.872)"
        ></rect>
        <path
          d="M550.633 48.04a4.452 4.452 0 10-8.9 0"
          className="cls-1"
          transform="translate(-503.768 -28.357)"
        ></path>
        <circle
          cx="3.749"
          cy="3.749"
          r="3.749"
          className="cls-1"
          transform="translate(38.429 15.934)"
        ></circle>
        <circle
          cx="1.874"
          cy="1.874"
          r="1.874"
          className="cls-3"
          transform="translate(40.304 17.809)"
        ></circle>
        <path
          d="M501.393 48.04a4.452 4.452 0 10-8.9 0h-2.343"
          className="cls-1"
          transform="translate(-477.961 -28.357)"
        ></path>
        <circle
          cx="3.749"
          cy="3.749"
          r="3.749"
          className="cls-1"
          transform="translate(14.997 15.934)"
        ></circle>
        <circle
          cx="1.874"
          cy="1.874"
          r="1.874"
          className="cls-3"
          transform="translate(16.871 17.809)"
        ></circle>
        <path
          fill="none"
          stroke="#2a2e43"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.284"
          d="M34.68 12.419h2.344a.7.7 0 01-.7.7h-.937a.7.7 0 01-.7-.7z"
          style={{ isolation: "isolate" }}
          opacity="0.2"
        ></path>
        <path
          d="M535.164 37.961h2.344a.469.469 0 01-.469.469h-1.406a.469.469 0 01-.469-.469z"
          className="cls-2"
          transform="translate(-500.484 -25.542)"
        ></path>
        <circle
          cx="0.703"
          cy="0.703"
          r="0.703"
          className="cls-1"
          transform="translate(.938 17.575)"
        ></circle>
        <circle
          cx="0.703"
          cy="0.703"
          r="0.703"
          className="cls-2"
          transform="translate(2.577 17.575)"
        ></circle>
        <circle
          cx="0.703"
          cy="0.703"
          r="0.703"
          className="cls-1"
          transform="translate(10.779 17.575)"
        ></circle>
        <circle
          cx="0.703"
          cy="0.703"
          r="0.703"
          className="cls-2"
          transform="translate(9.139 17.575)"
        ></circle>
        <g transform="translate(13.591 1.875)">
          <path
            d="M523.44 16.859a.469.469 0 01.469.469v12.185a.469.469 0 01-.469.469.469.469 0 01-.469-.469V17.328a.469.469 0 01.469-.469z"
            className="cls-5"
            transform="translate(-507.974 -16.859)"
          ></path>
          <path
            d="M515.937 16.859a.469.469 0 01.469.469v12.185a.469.469 0 01-.469.469.469.469 0 01-.469-.469V17.328a.469.469 0 01.469-.469z"
            className="cls-5"
            transform="translate(-504.22 -16.859)"
          ></path>
          <path
            d="M508.434 16.859a.469.469 0 01.469.469v12.185a.469.469 0 01-.469.469.469.469 0 01-.469-.469V17.328a.469.469 0 01.469-.469z"
            className="cls-5"
            transform="translate(-500.467 -16.859)"
          ></path>
          <path
            d="M500.931 16.859a.469.469 0 01.469.469v12.185a.469.469 0 01-.469.469.469.469 0 01-.469-.469V17.328a.469.469 0 01.469-.469z"
            className="cls-5"
            transform="translate(-496.713 -16.859)"
          ></path>
          <path
            d="M493.428 16.859a.469.469 0 01.469.469v12.185a.469.469 0 01-.469.469.469.469 0 01-.469-.469V17.328a.469.469 0 01.469-.469z"
            className="cls-5"
            transform="translate(-492.959 -16.859)"
          ></path>
        </g>
        <g transform="translate(2.343 1.875)">
          <path
            d="M485.925 16.859a.469.469 0 01.469.469v12.185a.469.469 0 01-.469.469.469.469 0 01-.469-.469V17.328a.469.469 0 01.469-.469z"
            className="cls-5"
            transform="translate(-477.958 -16.859)"
          ></path>
          <path
            d="M478.422 16.859a.469.469 0 01.469.469v12.185a.469.469 0 01-.469.469.469.469 0 01-.469-.469V17.328a.469.469 0 01.469-.469z"
            className="cls-5"
            transform="translate(-474.204 -16.859)"
          ></path>
          <path
            d="M470.919 16.859a.469.469 0 01.469.469v12.185a.469.469 0 01-.469.469.469.469 0 01-.469-.469V17.328a.469.469 0 01.469-.469z"
            className="cls-5"
            transform="translate(-470.45 -16.859)"
          ></path>
        </g>
      </g>
    </svg>
  );
}

export default TruckL;
